import { render, staticRenderFns } from "./Produit.vue?vue&type=template&id=76de85f0&scoped=true&"
import script from "./Produit.vue?vue&type=script&lang=js&"
export * from "./Produit.vue?vue&type=script&lang=js&"
import style0 from "./Produit.vue?vue&type=style&index=0&id=76de85f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76de85f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
installComponents(component, {VImg})
